import validate from "/home/runner/work/website/website/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.11.18_eslint@8.33.0_typescript@4.9.4/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/home/runner/work/website/website/middleware/redirects.global.ts";
export const globalMiddleware = [
  validate,
  redirects_45global
]
export const namedMiddleware = {}